var React = require('react');
var Table = require('react-bootstrap').Table;

var AttributeTable = React.createClass({
    propTypes: {
        attributes: React.PropTypes.array.isRequired
    },
    render: function () {
        var attributeMarkup = this.props.attributes.map(function (attribute, i) {
            return <tr key={attribute.name}>
                <th>
                    {attribute.help ? <a className="help" title={attribute.help}><i className="fa fa-question-circle"></i></a> : null}
                    {attribute.name}
                </th>
                <td>{attribute.value}</td>
            </tr>;
        });

        return <Table className="table-striped table-hover">
            {attributeMarkup}
        </Table>;
    }
})
module.exports = AttributeTable;



// WEBPACK FOOTER //
// ./app/components/AttributeTable.js